import React from 'react';
import { brandByKey, brands, criteria } from '../../data/strategy';
import { BrandLegend } from '../deck/BrandLegend';
import { PerceptionChart, type ChartRow } from '../deck/PerceptionChart';
import { SlideFrame } from '../deck/SlideFrame';
function buildRows(view: 'hcp' | 'leo'): ChartRow[] {
  return criteria.map(criterion => ({
    label: criterion.label,
    points: brands.map(brand => ({
      key: brandByKey[brand.key].name,
      value: criterion[view][brand.key],
      color: brand.color
    }))
  }));
}
const hcpRows = buildRows('hcp');
const leoRows = buildRows('leo');
export function WarfareSlide() {
  return <SlideFrame marker="Steps 02 + 03 side by side" data-id="element-163" data-mp="2bldtzuizoy81">
      <div className="shrink-0" data-id="element-164" data-mp="26m104ptpaqvy">
        <h2 className="font-display text-[clamp(26px,4vw,66px)] leading-none tracking-[-0.015em] text-ink" data-id="element-165" data-mp="26n2k5jsp2npt">
          Warfare{' '}
          <span className="text-[clamp(13px,1.7vw,28px)] font-sans font-medium tracking-normal text-ink-soft" data-id="element-166" data-mp="9reip95vagvc">
            prescription criteria
          </span>
        </h2>
      </div>

      <div className="mt-[3vh] flex min-h-0 flex-1 gap-[5%]" data-id="element-167" data-mp="3un3ky8ysm65h">
        {[{
        title: 'HCP perception',
        axis: 'Perceived strength (1 = weaker → 5 = stronger)',
        rows: hcpRows
      }, {
        title: 'Roche fact base',
        axis: 'Defensible strength (1 = weaker → 5 = stronger)',
        rows: leoRows
      }].map(panel => <div key={panel.title} className="flex min-h-0 flex-1 flex-col" data-id="element-168" data-mp="i9dscmzm5afj">
            <h3 className="shrink-0 pb-[1.8vh] text-center text-[clamp(12px,1.5vw,25px)] font-semibold text-ink" data-id="element-169" data-mp="m7tlz9q79h1x">
              {panel.title}
            </h3>
            <div className="min-h-0 flex-1" data-id="element-170" data-mp="dfhwpr6tnznj">
              <PerceptionChart rows={panel.rows} axisLabel={panel.axis} highlightKey="ROCHE" labelWidth="34%" compact data-id="element-171" data-mp="deghdairwr00" />
            </div>
          </div>)}
      </div>

      <div className="mt-[2.4vh] flex shrink-0 items-center justify-center" data-id="element-172" data-mp="1frjd7f2n7p6s">
        <BrandLegend variant="bar" className="max-w-[62%]" data-id="element-173" data-mp="1asydrhv7t9je" />
      </div>
    </SlideFrame>;
}